import { cardItem } from "../common/CardTmpl";
import Common from '../common/CommonNctv';

export default class AbsSection {
    constructor(_container='', _dataM={}, _option={}, _alias=''){
        if (this.constructor === AbsSection) {
            throw new TypeError("Cannot construct AbsSection instances directly");
        }
        this.com = Common.instance;
        this.container = _container;
        this.dataM = _dataM;
        this.alias = _alias;
        this.cardItemTmpl = cardItem;

        this.option = _option;
        this.isShow = _option.showArea;
        this.useManualData = _option.useManualData;

        $( this.container ).toggle(this.isShow);
    }

    init(){
        if( this.isShow ) {
            this.setTemplate();
        }
    }
    
    addEvents(){
        if( this.isShow ) {
            this.setEvents();
        }
    }
    
    setTemplate(){}
    
    setEvents(){}
    
} // end of class